'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const FormControl = _ref => {
  let {
    children,
    error,
    helperText
  } = _ref;
  const {
    captiontextDefaultNone,
    captiontextErrorNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement("div", null, children, /*#__PURE__*/React__default["default"].createElement("div", {
    role: "status",
    style: {
      paddingTop: helperText ? '0.25rem' : 0,
      ...(error ? captiontextErrorNone : captiontextDefaultNone)
    }
  }, helperText));
};
var FormControl$1 = nthHookTheme.withThemeProvider(FormControl, {
  themeTokens: ['captiontextDefaultNone', 'captiontextErrorNone']
});

exports["default"] = FormControl$1;
